// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__31mWi","textarea_label":"Textarea_textarea_label__3Awvp"};